"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TagVisibility_vue_1 = __importDefault(require("./TagVisibility.vue"));
const TagSynthetic_vue_1 = __importDefault(require("./TagSynthetic.vue"));
const ModelCompositorGisArea_1 = __importDefault(require("../abstract/models/ModelCompositorGisArea"));
const trans_1 = require("@common/tsutils/trans");
let Table = class Table extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.areasChecked = [];
        this.currentCropId = 0;
        this.currentAreaId = 0;
        this.minDate = new Date();
        this.maxDate = new Date();
        this.baseGisArea = 0;
        this.gisAreasObjectsChecked = [];
        this.applyRange = false;
    }
    get tableHeaderElements() {
        return [
            { name: (0, trans_1.trans)('composition_tool.table.th1') },
            { name: (0, trans_1.trans)('composition_tool.table.th2') },
            { name: (0, trans_1.trans)('composition_tool.table.th3') },
            { name: (0, trans_1.trans)('composition_tool.table.th4') },
            { name: (0, trans_1.trans)('composition_tool.table.th5') },
            { name: (0, trans_1.trans)('composition_tool.table.th6') },
        ];
    }
    resetGisAreasChecked() {
        this.areasChecked = [];
        this.gisAreasObjectsChecked = [];
        this.currentCropId = 0;
        this.minDate = new Date();
        this.maxDate = new Date();
        this.applyRange = false;
    }
    emitAreasChecked() {
        this.$emit('areasChecked', this.areasChecked);
    }
    getAlphaCategory(category) {
        if (category === 'A++')
            return 'AAA';
        if (category === 'A+')
            return 'AA';
        return category;
    }
    isGisAreaCheck(areaId) {
        if (this.areasChecked.includes(areaId)) {
            return true;
        }
        return false;
    }
    addNewArea(newValue, areaId, cropId) {
        this.pushFn(areaId, cropId);
    }
    isOld(area) {
        return new Date().getFullYear() - parseInt(area.due_date.split(' ')[0]) >= 1;
    }
    addDecreaseDate(meses, date) {
        const fechaOriginal = new Date(date);
        fechaOriginal.setMonth(fechaOriginal.getMonth() + meses);
        return fechaOriginal.toISOString().slice(0, 19).replace('T', ' ');
    }
    currenArea(id) {
        return new ModelCompositorGisArea_1.default(this.gisAreas.filter((area) => {
            return area.gis_area_id === id;
        })[0]);
    }
    isRangeDate(area) {
        if (new Date(area.due_date) <= new Date(this.maxDate) &&
            new Date(area.due_date) >= new Date(this.minDate)) {
            return true;
        }
        else {
            return false;
        }
    }
    parseFecha(fechaStr) {
        const partes = fechaStr.split(' ');
        const fecha = partes[0];
        const hora = partes[1] || '00:00:00';
        return new Date(`${fecha}T${hora}`);
    }
    calculatedRange(areasChecked) {
        for (const areaId of areasChecked) {
            this.gisAreasObjectsChecked.push(this.currenArea(areaId));
        }
        if (this.gisAreasObjectsChecked.length > 0) {
            const objetoFechaMasAlta = this.gisAreasObjectsChecked.reduce((anterior, actual) => {
                const fechaAnterior = this.parseFecha(anterior.due_date);
                const fechaActual = this.parseFecha(actual.due_date);
                return fechaAnterior < fechaActual ? actual : anterior;
            });
            const objetoFechaMasBaja = this.gisAreasObjectsChecked.reduce((anterior, actual) => {
                const fechaAnterior = this.parseFecha(anterior.due_date);
                const fechaActual = this.parseFecha(actual.due_date);
                return fechaAnterior > fechaActual ? actual : anterior;
            });
            const año1 = new Date(objetoFechaMasBaja.due_date).getFullYear();
            const mes1 = new Date(objetoFechaMasBaja.due_date).getMonth();
            const año2 = new Date(objetoFechaMasAlta.due_date).getFullYear();
            const mes2 = new Date(objetoFechaMasAlta.due_date).getMonth();
            const dif = (año2 - año1) * 12 + (mes2 - mes1);
            const minDate = new Date(objetoFechaMasBaja.due_date);
            minDate.setMonth(minDate.getMonth() - (6 - dif));
            const maxDate = new Date(objetoFechaMasAlta.due_date);
            maxDate.setMonth(maxDate.getMonth() + (6 + dif));
            this.minDate = minDate;
            this.maxDate = maxDate;
            this.applyRange = true;
            this.gisAreasObjectsChecked = [];
        }
    }
    pushFn(areaId, cropId) {
        if (this.currentCropId !== cropId && this.currentCropId !== 0) {
            this.resetGisAreasChecked();
        }
        if (this.areasChecked.includes(areaId)) {
            const indexToRemove = this.areasChecked.indexOf(areaId);
            this.areasChecked.splice(indexToRemove, 1);
            if (this.areasChecked.length < 1) {
                this.resetGisAreasChecked();
            }
        }
        else {
            if (!this.currenArea(areaId).is_synthetic) {
                if (!this.isOld(this.currenArea(areaId))) {
                    if (this.applyRange) {
                        if (this.isRangeDate(this.currenArea(areaId))) {
                            this.areasChecked.push(areaId);
                        }
                    }
                    else {
                        this.areasChecked.push(areaId);
                    }
                }
            }
        }
        this.areasChecked = this.areasChecked.filter((item, index) => {
            return this.areasChecked.indexOf(item) === index;
        });
        if (this.areasChecked.length > 0) {
            this.calculatedRange(this.areasChecked);
        }
        for (const areaId of this.areasChecked) {
            if (!this.isRangeDate(this.currenArea(areaId))) {
                const indexToRemove = this.areasChecked.indexOf(areaId);
                this.areasChecked.splice(indexToRemove, 1);
            }
        }
        this.currentCropId = cropId;
    }
    formatNumberTwoDecimals(number) {
        return Math.round(number * 100) / 100;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], Table.prototype, "gisAreas", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('gisAreas')
], Table.prototype, "resetGisAreasChecked", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('areasChecked')
], Table.prototype, "emitAreasChecked", null);
Table = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            CheckBox: bmk_ui_framework_1.CheckBox,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            TagVisibility: TagVisibility_vue_1.default,
            TagSynthetic: TagSynthetic_vue_1.default,
            DateStylized: bmk_ui_framework_1.DateStylized,
        },
    })
], Table);
exports.default = Table;
